export const reduceMultipleSpaces = (value) => {
  value = value.replace(/\s+/g, " ");
  return value;
};
